import React, { useEffect, useState } from "react";
import { TableActionBar } from "@amzn/meridian/table";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import Input from "@amzn/meridian/input";
import viewToken from "@amzn/meridian-tokens/base/icon/view";
import filterTokens from "@amzn/meridian-tokens/base/icon/filter";
import { useSheets } from "../../features/sheets/hooks";
import { useFilterSheets } from "../../features/filter-sheets/hooks";
import { useAppDispatch } from "../../app/store/hooks";
import { tableMapping } from "./definitions";
import { exportCurrentTable } from "./utils";
import refreshTokens from "@amzn/meridian-tokens/base/icon/refresh";
import { useTable } from "./hooks";

export interface ITableHeaderProps {
    setTableSearchInput: (value) => void;
    tableSearchInput: string;
    tableData: any;
    currentTable: string;
    setOpenPreferenceModal?: (value) => void;
    preferences?: any;
}

export const TableHeader: React.FC<ITableHeaderProps> = ({
    tableData,
    currentTable,
    setOpenPreferenceModal,
}) => {
    const dispatch = useAppDispatch();
    const { sheets, setOpenSheets, updateSheets } = useSheets();
    const { handleFilterMapUpdate } = useFilterSheets();
    const { updateCurrentTableId } = useTable();

    const [tableSearchQuery, setTableSearchQuery] = useState("");

    useEffect(() => {
        tableSearchQuery?.trim()
            ? dispatch(
                  handleFilterMapUpdate({
                      type: "UPDATE",
                      filterKey: "keyword",
                      value: tableSearchQuery,
                  })
              )
            : dispatch(
                  handleFilterMapUpdate({
                      type: "REMOVE",
                      filterKey: "keyword",
                  })
              );
    }, [tableSearchQuery]);

    return (
        <TableActionBar widths={[300, "fit", "fill"]}>
            <Input
                aria-label="Label"
                type="text"
                size="medium"
                placeholder="Search..."
                value={tableSearchQuery}
                onChange={e => setTableSearchQuery(e)}
            />

            <Button
                onClick={() => {
                    updateSheets(tableMapping[currentTable].filter);
                    setOpenSheets(!sheets.isSheetsOpen);
                }}
                type="icon"
            >
                <Icon tokens={filterTokens}></Icon>
            </Button>
            <div />

            {currentTable === "audit-records-mails" ||
            currentTable === "audit-records-data-source-files" ? (
                <Button
                    onClick={() => {
                        dispatch(updateCurrentTableId());
                    }}
                    type="icon"
                >
                    <Icon tokens={refreshTokens}></Icon>
                </Button>
            ) : null}
            <Button
                onClick={() => {
                    setOpenPreferenceModal(true);
                }}
                type="icon"
            >
                <Icon tokens={viewToken}></Icon>
            </Button>

            <Button onClick={() => exportCurrentTable(tableData, currentTable)} type="tertiary">
                Export
            </Button>
        </TableActionBar>
    );
};
